export function formatBRL(value: any) {
    const num = Number(value);
    return num > 0
      ? num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      : 'R$ 0,00';
  }
  